module.exports = __webpack_public_path__ + "img/按钮保存浅色.505a98a2.png";